import { useState } from 'react';

export default function usePagination(items, pageSize = 6, resetKey = '') {
  const [position, setPosition] = useState({ page: 1, key: resetKey });
  if (position.key !== resetKey) setPosition({ page: 1, key: resetKey });
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const page = position.key === resetKey ? Math.min(position.page, pageCount) : 1;
  const setPage = value => setPosition({ page: Math.max(1, Math.min(value, pageCount)), key: resetKey });
  const offset = (page - 1) * pageSize;
  return { page, pageCount, setPage, total: items.length, pageSize, offset, items: items.slice(offset, offset + pageSize) };
}
